var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00C271"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4727 10.1952L21.8061 7.52853C21.7442 7.46662 21.6707 7.41751 21.5898 7.384C21.5089 7.3505 21.4222 7.33325 21.3346 7.33325C21.2471 7.33325 21.1604 7.3505 21.0795 7.384C20.9986 7.41751 20.9251 7.46662 20.8632 7.52853L12.8632 15.5285C12.7382 15.6536 12.668 15.8231 12.668 15.9999V18.6666C12.668 18.8434 12.7382 19.013 12.8632 19.138C12.9883 19.263 13.1578 19.3333 13.3346 19.3333H16.0013C16.1781 19.3333 16.3477 19.263 16.4727 19.138L24.4727 11.138C24.5978 11.013 24.668 10.8434 24.668 10.6666C24.668 10.4898 24.5978 10.3202 24.4727 10.1952V10.1952ZM22.0013 11.7238L20.2775 9.99993L21.3346 8.94274L23.0585 10.6666L22.0013 11.7238Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4684 14.0272L17.4152 20.0803C17.2299 20.2666 17.0095 20.4143 16.7668 20.5149C16.524 20.6155 16.2637 20.6669 16.001 20.6662H13.3343C12.8041 20.6656 12.2957 20.4547 11.9207 20.0797C11.5458 19.7048 11.3349 19.1964 11.3343 18.6662V15.9995C11.3336 15.7368 11.385 15.4765 11.4855 15.2338C11.5861 14.991 11.7338 14.7706 11.9201 14.5854L17.9749 8.53052C17.9459 8.38187 17.8664 8.24781 17.7499 8.15104C17.6334 8.05427 17.4871 8.00074 17.3356 7.99951H9.33431C8.9808 7.99986 8.64186 8.14045 8.39189 8.39042C8.14191 8.64039 8.00133 8.97933 8.00098 9.33285V22.6662C8.00133 23.0197 8.14191 23.3586 8.39189 23.6086C8.64186 23.8586 8.9808 23.9992 9.33431 23.9995H22.6676C23.0212 23.9992 23.3601 23.8586 23.6101 23.6086C23.86 23.3586 24.0006 23.0197 24.001 22.6662V14.6668C23.9998 14.5151 23.9461 14.3685 23.849 14.2519C23.7519 14.1353 23.6174 14.0559 23.4684 14.0272V14.0272Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.26496bc29635f7eac1a9c7b3881e70dc.svg";
export { ForwardRef as ReactComponent };